import * as React from 'react';
// @ts-expect-error
import type {DragHandleProps} from 'react-beautiful-dnd';

import classnames from 'classnames';

import {Card} from '../card/card';
// @ts-expect-error - imported from .js/.jsx file
import {DragHandleIcon} from '../icon/svg/drag-handle-icon';

import styles from './draggable-row.module.css';

type Props = {
    children: any;
    dragHandleProps?: DragHandleProps;
    disabled?: boolean;
    showOverflow?: boolean;
    showHandleWhenDisabled?: boolean;
};

export class DraggableRow extends React.PureComponent<Props> {
    render() {
        // Don't leave a gap on the right side of the row when the drag handle
        // is disabled
        const width = this.props.disabled ? '100%' : 'calc(100% - 28px)';

        const styleNames = classnames(styles['draggable-row'], {
            [styles['show-overflow']]: this.props.showOverflow,
        });

        const handleStyleNames = classnames(styles['drag-handle'], {
            [styles['show-handle-when-disabled']]:
                this.props.showHandleWhenDisabled && this.props.disabled,
        });

        return (
            <Card hasBorder={true} hasShadow={true} overflowVisible={this.props.showOverflow}>
                <div className={styleNames}>
                    {(!this.props.disabled || this.props.showHandleWhenDisabled) && (
                        <div
                            {...this.props.dragHandleProps}
                            className={classnames(
                                handleStyleNames,
                                this.props.dragHandleProps?.className
                            )}
                        >
                            <DragHandleIcon size={14} />
                        </div>
                    )}
                    <div style={{width}}>{this.props.children}</div>
                </div>
            </Card>
        );
    }
}
